import type { FC } from 'react'

import { ServicesPage } from 'components'

const Services: FC = () => <ServicesPage />

export default Services
